var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasSuggestions
    ? _c("section", { staticClass: "suggestions" }, [
        _vm.suggestions.events.length > 0
          ? _c("div", { staticClass: "suggestions__column" }, [
              _c("section", { staticClass: "suggestions__section" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "suggestions__list" },
                  _vm._l(_vm.suggestions.events, function(event) {
                    return _c(
                      "li",
                      { key: event.id, staticClass: "suggestions__item" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "suggestions__link",
                            class: {
                              "suggestions__link--highlighted":
                                _vm.highlightedSuggestion !== null &&
                                _vm.highlightedSuggestion.data === event
                            },
                            attrs: {
                              tabindex: "-1",
                              to: _vm.makeEntityRoute("events", event)
                            },
                            nativeOn: {
                              click: function($event) {
                                _vm.onSuggestionClick({
                                  data: event,
                                  type: "events"
                                })
                              }
                            }
                          },
                          [
                            _vm._t(
                              "event",
                              [
                                _c("h4", { staticClass: "suggestions__name" }, [
                                  _vm._v(_vm._s(event.name))
                                ]),
                                _vm._v(" "),
                                event.is_date_tbd
                                  ? [_vm._v("Date TBD")]
                                  : event.is_time_tbd
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("date")(
                                            event.local_date,
                                            "ddd, MMM D"
                                          )
                                        ) + ", Time TBD"
                                      )
                                    ]
                                  : [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("date")(
                                            event.local_date,
                                            "ddd, MMM D, h:mma"
                                          )
                                        )
                                      )
                                    ],
                                _vm._v(
                                  "\n                            – " +
                                    _vm._s(event.venue)
                                ),
                                event.city
                                  ? [_vm._v(", " + _vm._s(event.city))]
                                  : _vm._e(),
                                event.region
                                  ? [_vm._v(", " + _vm._s(event.region))]
                                  : _vm._e()
                              ],
                              { event: event }
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  })
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.suggestions.performers.length > 0 ||
        _vm.suggestions.venues.length > 0 ||
        _vm.suggestions.cities.length > 0
          ? _c("div", { staticClass: "suggestions__column" }, [
              _vm.suggestions.performers.length > 0
                ? _c("section", { staticClass: "suggestions__section" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "suggestions__list" },
                      _vm._l(_vm.suggestions.performers, function(performer) {
                        return _c(
                          "li",
                          {
                            key: performer.id,
                            staticClass: "suggestions__item"
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "suggestions__link",
                                class: {
                                  "suggestions__link--highlighted":
                                    _vm.highlightedSuggestion !== null &&
                                    _vm.highlightedSuggestion.data === performer
                                },
                                attrs: {
                                  tabindex: "-1",
                                  to: _vm.makeEntityRoute(
                                    "performers",
                                    performer
                                  )
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.onSuggestionClick({
                                      data: performer,
                                      type: "performers"
                                    })
                                  }
                                }
                              },
                              [
                                _vm._t(
                                  "performer",
                                  [
                                    _c(
                                      "h4",
                                      { staticClass: "suggestions__name" },
                                      [_vm._v(_vm._s(performer.name))]
                                    ),
                                    _vm._v(" "),
                                    _vm.isNumber(performer.count)
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              performer.count +
                                                " " +
                                                (performer.count === 1
                                                  ? "event"
                                                  : "events")
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ],
                                  { performer: performer }
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      })
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.suggestions.venues.length > 0
                ? _c("section", { staticClass: "suggestions__section" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "suggestions__list" },
                      _vm._l(_vm.suggestions.venues, function(venue) {
                        return _c(
                          "li",
                          { key: venue.id, staticClass: "suggestions__item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "suggestions__link",
                                class: {
                                  "suggestions__link--highlighted":
                                    _vm.highlightedSuggestion !== null &&
                                    _vm.highlightedSuggestion.data === venue
                                },
                                attrs: {
                                  tabindex: "-1",
                                  to: _vm.makeEntityRoute("venues", venue)
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.onSuggestionClick({
                                      data: venue,
                                      type: "venues"
                                    })
                                  }
                                }
                              },
                              [
                                _vm._t(
                                  "venue",
                                  [
                                    _c(
                                      "h4",
                                      { staticClass: "suggestions__name" },
                                      [_vm._v(_vm._s(venue.name))]
                                    ),
                                    _vm._v(" "),
                                    _vm.isNumber(venue.count)
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              venue.count +
                                                " " +
                                                (venue.count === 1
                                                  ? "event"
                                                  : "events")
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ],
                                  { venue: venue }
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      })
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.suggestions.cities.length > 0
                ? _c("section", { staticClass: "suggestions__section" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "suggestions__list" },
                      _vm._l(_vm.suggestions.cities, function(city) {
                        return _c(
                          "li",
                          { key: city.id, staticClass: "suggestions__item" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "suggestions__link",
                                class: {
                                  "suggestions__link--highlighted":
                                    _vm.highlightedSuggestion !== null &&
                                    _vm.highlightedSuggestion.data === city
                                },
                                attrs: {
                                  tabindex: "-1",
                                  to: _vm.makeEntityRoute("cities", city)
                                },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.onSuggestionClick({
                                      data: city,
                                      type: "cities"
                                    })
                                  }
                                }
                              },
                              [
                                _vm._t(
                                  "city",
                                  [
                                    _c(
                                      "h4",
                                      { staticClass: "suggestions__name" },
                                      [_vm._v(_vm._s(city.name))]
                                    ),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          city.count +
                                            " " +
                                            (city.count === 1
                                              ? "event"
                                              : "events")
                                        ) +
                                        "\n                        "
                                    )
                                  ],
                                  { city: city }
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      })
                    )
                  ])
                : _vm._e()
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "suggestions__group-heading" }, [
      _c("span", { staticClass: "icon icon-clock" }),
      _vm._v(" Upcoming Events")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "suggestions__group-heading" }, [
      _c("span", { staticClass: "icon icon-shirt" }),
      _vm._v(" Performers")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "suggestions__group-heading" }, [
      _c("span", { staticClass: "icon icon-venue" }),
      _vm._v(" Venues")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "suggestions__group-heading" }, [
      _c("span", { staticClass: "icon icon-location-marker" }),
      _vm._v(" Cities")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }